import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}
function getHeaders2() {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

function getHeaders3() {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}
// Import Contacts via Excel

// export const importContacts = async (
//   file,
//   segmentName,
//   segmentCategoryName
// ) => {
//   const formData = new FormData();
//   formData.append("excel_file", file);
//   formData.append("segment_name", segmentName);
//   formData.append("segment_category_name", segmentCategoryName);

//   try {
//     const response = await axios.post(
//       `${process.env.REACT_APP_BASE_URL}/sales/import-contact/`, // Backend endpoint
//       formData,
//       getHeaders2()
//     );
//     "ImportContactService Response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("ImportContacts Error:", error.response);
//     throw new Error(
//       error.response?.data?.message || "Failed to import contacts"
//     );
//   }
// };
export const importContacts = async (formdata) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/sales/import-contact/`,
      formdata,
      getHeaders3()
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch campaigns"
    );
  }
};
// Get Campaigns List
export const getCampaigns = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/sales/camping-list/`,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch campaigns"
    );
  }
};

// Create a Campaign
export const createCampaign = async (campaignData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/sales/camping-list/`,
      campaignData,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create campaign"
    );
  }
};

// Get Segments
export const getSegments = async (data) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/sales/segmsents/`,
      data,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch segments"
    );
  }
};

// Create a Segment
export const createSegment = async (segmentData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/sales/segmsents/`,
      segmentData,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create segment"
    );
  }
};
export const addContacts = async (segmentData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/sales/import-contact/`,
      segmentData,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create segment"
    );
  }
};

// Update a Segment
export const updateSegment = async (segment__id, segmentData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/sales/segmsents/${segment__id}/`,
      segmentData,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update segment"
    );
  }
};

// Delete a Segment
export const deleteSegment = async (segment__id, updatedData) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/sales/segmsents/${segment__id}/`,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete segment"
    );
  }
};

// Get Segment Counts by Category
export const getSegmentCounts = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/sales/segmsents/`,
      getHeaders()
    );
    return response.data.segment_counts;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch segment counts"
    );
  }
};

export const updateCampaign = async (campaignId, data) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/sales/campaigns/${campaignId}/`,
      data,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update segment"
    );
  }
};

// Delete a Segment
export const deleteCampaign = async (campaignId, data) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/sales/campaigns/${campaignId}/`,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete segment"
    );
  }
};
